/// <amd-module name="typeahead/core/geolocation/message/GeolocationClearedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionResult} from "typeahead/core/Suggestion";

export class GeolocationClearedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.geolocation_cleared";
    }

    constructor(private domElementId: string, private readonly geolocationResult: ISuggestionResult) {}

    public getTopic(): string {
        return GeolocationClearedMessage.getTopic();
    }

    public getGeolocationResult(): ISuggestionResult {
        return this.geolocationResult;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }
}
